

/**
 * 设置Cookie
 * @param {string} key - Cookie键名
 * @param {string|number|boolean} value - Cookie值
 * @param {Object} options - 配置选项
 */

export function setCookie(key, value, options = {}) {
    const {
    expires,
    expiresDate,
    path = '/',
    domain = '',
    secure = false,
    sameSite = 'Lax',
  } = options

  let cookieString = encodeURIComponent(key) + '=' + encodeURIComponent(value)

  if (expiresDate) {
    cookieString += '; expires=' + expiresDate.toUTCString()
  } else if (expires) {
    const date = new Date()
    date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000)
    cookieString += '; expires=' + date.toUTCString()
  }

  if (path) {cookieString += '; path=' + path}
  if (domain) {cookieString += '; domain=' + domain}
  if (secure) {cookieString += '; secure'}
  if (sameSite) {cookieString += '; samesite=' + sameSite}

  document.cookie = cookieString
}

/**
 * 获取Cookie值
 * @param {string} key - Cookie键名
 * @returns {string|null} Cookie值
 */
export function getCookie(key) {
  const name = encodeURIComponent(key) + '='
  const cookies = document.cookie.split(';')

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim()
    if (cookie.indexOf(name) === 0) {
      return decodeURIComponent(cookie.substring(name.length))
    }
  }

  return null
}

/**
 * 删除Cookie
 * @param {string} key - Cookie键名
 * @param {string} path - 路径
 * @param {string} domain - 域名
 */
export function deleteCookie(key, path = '/', domain = '') {
  setCookie(key, '', {
    expiresDate: new Date(0),
    path,
    domain
  })
}

/**
 * 检查Cookie是否存在
 * @param {string} key - Cookie键名
 * @returns {boolean} 是否存在
 */
export function hasCookie(key) {
  return getCookie(key) !== null
}

/**
 * 获取所有Cookie
 * @returns {Object} 所有Cookie对象
 */
export function getAllCookies() {
  const cookies = {}
  const cookieList = document.cookie.split(';')

  cookieList.forEach(cookie => {
    const [key, value] = cookie.trim().split('=')
    if (key && value) {
      cookies[decodeURIComponent(key)] = decodeURIComponent(value)
    }
  })

  return cookies
}

/**
 * 清除所有Cookie
 * @param {string} path - 路径
 * @param {string} domain - 域名
 */
export function clearAllCookies(path = '/', domain = '') {
  const cookies = getAllCookies()
  Object.keys(cookies).forEach(key => {
    deleteCookie(key, path, domain)
  })
}

/**
 * 获取JSON格式的Cookie
 * @param {string} key - Cookie键名
 * @returns {Object|null} JSON对象
 */
export function getCookieJSON(key) {
  const value = getCookie(key)
  if (!value) {
    return null
  }

  try {
    return JSON.parse(value)
  } catch (error) {
    console.error('解析JSON失败:', error)
    return null
  }
}

/**
 * 设置JSON格式的Cookie
 * @param {string} key - Cookie键名
 * @param {any} value - JSON对象
 * @param {Object} options - 配置选项
 */
export function setCookieJSON(key, value, options = {}) {
  const jsonString = JSON.stringify(value)
  setCookie(key, jsonString, options)
}

/**
 * 统一导出所有方法
 */
export const cookie = {
  set: setCookie,
  get: getCookie,
  delete: deleteCookie,
  has: hasCookie,
  getAll: getAllCookies,
  clearAll: clearAllCookies,
  getJSON: getCookieJSON,
  setJSON: setCookieJSON
}


export default cookie